import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-home-pricing',
  templateUrl: './home-pricing.component.html',
  styleUrls: ['./home-pricing.component.scss']
})
export class HomePricingComponent {
  @Input() educationalOffers: any[] = [];
}